import { render } from "./StepsTight.vue?vue&type=template&id=44422b5b&scoped=true"
import script from "./StepsTight.vue?vue&type=script&lang=js"
export * from "./StepsTight.vue?vue&type=script&lang=js"

import "./StepsTight.vue?vue&type=style&index=0&id=44422b5b&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44422b5b"]])

export default __exports__